import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateFull } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/common/Bits";
import { Tag } from "@/components/common/StatusChip";

const TONE = (a) => (a.startsWith("auth.impersonate") || a.startsWith("auth.force") ? "amber" : a.startsWith("backup") ? "cyan" : a.startsWith("role") || a.startsWith("user") ? "purple" : a.startsWith("inactivity") ? "red" : "neutral");

export default function Audit() {
  const [q, setQ] = useState("");
  const { data: rows = [] } = useQuery({ queryKey: ["audit", q], queryFn: () => api.get("/audit", { params: { q: q || undefined } }).then((r) => r.data), refetchInterval: 20000 });
  return (
    <div data-testid="audit-page">
      <PageHeader eyebrow="Compliance" title="Audit log" description="System-wide record of sign-ins, view-as sessions, permission changes, rule edits, restores and automation runs. Per-ticket history lives on each ticket." />
      <div className="p-4 md:p-6">
        <div className="relative mb-3 max-w-sm"><Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search actor, action or summary" className="h-8 pl-8 text-xs" data-testid="audit-search-input" /></div>
        <div className="surface overflow-x-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead><tr className="border-b border-border text-left">{["When", "Actor", "Action", "Summary"].map((h) => <th key={h} className="eyebrow px-4 py-2">{h}</th>)}</tr></thead>
            <tbody className="divide-y divide-border">
              {rows.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-xs text-muted-foreground">Nothing recorded yet.</td></tr>}
              {rows.map((r) => (
                <tr key={r.id} className="row-hover align-top" data-testid={`audit-row-${r.id}`}>
                  <td className="mono whitespace-nowrap px-4 py-2 text-[11px] text-muted-foreground">{fmtDateFull(r.at)}</td>
                  <td className="px-4 py-2 text-xs"><div className="font-semibold">{r.actor?.name || "System"}</div>{r.actor?.impersonator && <div className="text-[11px] text-amber-500">viewed as by {r.actor.impersonator.name}</div>}</td>
                  <td className="px-4 py-2"><Tag tone={TONE(r.action)}>{r.action}</Tag></td>
                  <td className="px-4 py-2 text-xs">{r.summary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
